import React from 'react';
import PropTypes from 'prop-types';

import './StatesDescriptionUnit.scss';

const StatesDescriptionUnit = ({ title, description }) => {
    return (
        <div className="states-description-unit">
            <div className="title is-bold">{title}</div>
            <div className="content sr-text is-small is-light">{description}</div>
        </div>
    );
};

StatesDescriptionUnit.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
};

export default StatesDescriptionUnit;



// WEBPACK FOOTER //
// ./src/components/EstimateTradeIn/components/StatesDescription/StatesDescriptionUnit.jsx